/* eslint-disable */
import Axios from 'axios';
import Qs from 'qs';
import { Message } from 'iview';
import Router from 'vue-router'
export const config = {
    BASE_URL: '', // 自动加在url前
    // API_URL: 'http://www.newstring.xyz:21002',
    // API_URL: 'https://www.changchengshangpu.com:21001',
    API_URL:'https://api.changchengshangpu.com',
    // API_URL:'https://39.98.82.90:21001',
    // API_URL: 'http://192.168.1.221:21001',
};

// 响应前
Axios.interceptors.request.use(
    _response => {
        return _response
    },
    _error => {
        return Promise.reject(_error)
    });

// 响应拦截（配置请求回来的信息）
Axios.interceptors.response.use(
    _response => {
      if (_response.data && _response.data.LoginSuccess === false) {
        sessionStorage.removeItem('menu');
        sessionStorage.removeItem('token');
        // Router.push(`/login`);
        Router.push({
          name: 'login'
        })
        Message.error(_response.data.Msg);//新增提示
      }
        return _response
    },
    error => {
        Message.error("系统错误 "+error);
        return Promise.reject(error)
    });

export function axios(_method, _url, _data,_params,responseType) {
    let token = sessionStorage.token || '';
    Axios.interceptors.request.use(
        _config => {
            return _config
        },
        _error => {
            return Promise.reject(_error)
        }
    );
    return Axios.request({
        method: _method,
        url: 'get' === _method ? (_url + (_url.indexOf("?") > -1 ? "&" : "?") + Qs.stringify(_data)) : _url,
        data: _data,
        params:_params,
        timeout: 300000,
        responseType: responseType?'blob':'json',
        withCredentials: true,
        headers:{ Authorization:token}
    });
}
/* eslint-enable */
